import { type DealFormData, dealSource } from '@openx/types/deal';
import type { ThirdPartyPartnerOptionApi } from '@openx/types/options';
import { type Path, useWatch } from 'react-hook-form';

export const useDefaultPlatformShare = (index: number, partnerById: Record<string, ThirdPartyPartnerOptionApi>) => {
  const partnerIdFieldName: Path<DealFormData> = `third_party_fees_config.${index}.partner_id`;

  const observableDealSource = useWatch<DealFormData, 'deal_source'>({ name: 'deal_source' });
  const observablePartnerId = useWatch<DealFormData, typeof partnerIdFieldName>({ name: partnerIdFieldName });

  const isOxBuyerSourced = observableDealSource === dealSource.OxBuyerDevSourced;
  const isOxDspSourced = observableDealSource === dealSource.OxDspSourced;
  const isOpenXSourced = isOxBuyerSourced || isOxDspSourced;
  const partner = observablePartnerId ? partnerById[observablePartnerId] : null;

  return {
    defaultPlatformShare: isOpenXSourced
      ? partner?.default_platform_share_ox_sourced
      : partner?.default_platform_share_partner_sourced,
  };
};
